import { createEvent, createStore } from 'effector'

export const actions = {
  setUser: createEvent<UserResponse>('setUser'),
  resetUser: createEvent('resetUser'),
  setLogged: createEvent<boolean>('setLogged'),
  setPreferences: createEvent<Partial<Preferences>>('setPreferences'),
  resetPreferences: createEvent('resetPreferences'),
  setFavoriteIncidents: createEvent<IncidentResponse[]>('setFavoriteIncidents'),
  addIncidentToFavorites: createEvent<IncidentResponse>('addIncidentToFavorites'),
  removeIncidentFromFavorites: createEvent<IncidentResponse>('removeIncidentFromFavorites'),
  reset: createEvent('reset'),
}

const initialState: UserState = {
  logged: false,
  user: undefined,
  lastUser: undefined,
  lastUserEmail: undefined,
  lastUpdate: undefined,
  preferences: {
    notifications: [],
  },
  favoriteIncidents: [],
}

export const store = createStore<UserState>(initialState, { name: 'user' })
  .on(actions.setUser, (s, user) => ({
    ...s,
    user,
    lastUser: user.id,
    lastUserEmail: user.email,
    lastUpdate: Date.now(),
    preferences: s.lastUser === user.id ? s.preferences : initialState.preferences, // reset on new user
  }))
  .on(actions.resetUser, (s) => ({ ...s, user: undefined, logged: false }))
  .on(actions.setLogged, (s, logged) => ({ ...s, logged }))
  .on(actions.setPreferences, (s, part) => ({
    ...s,
    lastUpdate: Date.now(),
    preferences: { ...s.preferences, ...part },
  }))
  .on(actions.resetPreferences, (s) => ({ ...s, preferences: initialState.preferences }))
  .on(actions.setFavoriteIncidents, (s, incidents) => ({
    ...s,
    favoriteIncidents: incidents,
  }))
  .on(actions.addIncidentToFavorites, (s, incident) => ({
    ...s,
    favoriteIncidents: [...s.favoriteIncidents, incident],
  }))
  .on(actions.removeIncidentFromFavorites, (s, incident) => ({
    ...s,
    favoriteIncidents: s.favoriteIncidents.filter((f) => f.id !== incident.id),
  }))
  .on(actions.reset, () => initialState)
